export enum EEventStatus {
  Inbox = 'inbox',
  UnderReview = 'underReview',
  Escalated = 'escalated',
  Completed = 'completed',
}

export enum EEventStatusLabel {
  inbox = 'Inbox',
  underReview = 'Under Review',
  escalated = 'Escalated',
  completed = 'Completed',
}

export enum EEventActionType {
  MoveToInbox = 'moveToInbox',
  Complete = 'complete',
  Back = 'back',
}

export enum EEventType {
  RequestCall = 'requestCall',
  Message = 'message',
  Call = 'call',
  Lucy = 'lucy',
}

export enum EEventTypeLabel {
  requestCall = 'Request a call',
  message = 'New Message',
  call = 'Outgoing call',
  lucy = 'L.U.C.Y',
}
